module.exports = __webpack_public_path__ + "img/Workers.7f80f0f.svg";